export const OrganismsDictionary = {
  comparators: {
    title: '1. Comparators:',
    panels: {
      panel001: {
        title: '1.1. Comparator',
        code: 'COMPARATOR-001'
      }
    }
  },
  filters: {
    title: '2. Filters:',
    panels: {
      panel001: {
        title: '2.1. Filter Generic',
        code: 'FILTER-001'
      },
      panel002: {
        title: '2.2. Filter Generic - With SubHeader',
        code: 'FILTER-002'
      },
      panel003: {
        title: '2.3. Filter Panel',
        code: 'FILTER-003'
      }
    }
  },
  forms: {
    title: '3. Forms:',
    panels: {
      panel001: {
        title: '3.1. Input-text',
        code: 'FORM-001'
      },
      panel002: {
        title: '3.2. Checkbox',
        code: 'FORM-002'
      }
    }
  },
  panels: {
    title: '4. Panels:',
    panels: {
      panel001: {
        title: '4.1. Panel-Collapsable',
        code: 'PANEL-001'
      },
      panel002: {
        title: '4.2. Panel',
        code: 'PANEL-002'
      },
      panel003: {
        title: '4.3. Scroll-Panel',
        code: 'PANEL-003'
      }
    }
  },
  tables: {
    title: '5. Tables:',
    panels: {
      panel001: {
        title: '5.1. Table-Generic',
        code: 'TABLE-001'
      }
    }
  },
  tabs: {
    title: '6. Tabs:',
    panels: {
      panel001: {
        title: '6.1. Tabs-Generic',
        code: 'TAB-001'
      }
    }
  },
  tree: {
    title: '7. Trees:',
    panels: {
      panel001: {
        title: '7.1. Tree',
        code: 'TREE-001'
      }
    }
  },
  splitters: {
    title: '8. Splitters:',
    panels: {
      panel001: {
        title: '8.1. Splitter',
        code: 'SPLITTER-001'
      }
    }
  },
  banners: {
    title: '9. Banners:',
    panels: {
      panel001: {
        title: '9.1. Banner-Generic',
        code: 'BANNER-001'
      }
    }
  }
};
